import { useState } from "react";
import api from "@/lib/api";

export default function WaitlistSignup({ product }) {
    const [email, setEmail] = useState("");
    const [name, setName] = useState("");
    const [ok, setOk] = useState(false);
    const [err, setErr] = useState("");
    const [saving, setSaving] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setErr("");
        if (!email.trim()) return setErr("Please add an email.");
        setSaving(true);
        try {
            const { data } = await api.post("/waitlist", {
                product_id: product.id,
                email: email.trim(),
                name: name.trim(),
            });
            setOk(true);
            setEmail(""); setName("");
        } catch (e2) {
            const d = e2?.response?.data?.detail;
            setErr(typeof d === "string" ? d : "Couldn't add you to the list. Please try again.");
        } finally {
            setSaving(false);
        }
    };

    const status = product?.status || "";
    const label = status === "sold" ? "Sold — join the waitlist"
        : status === "reserved" ? "Reserved — join the waitlist"
        : "Notify me when it's back";

    return (
        <div data-testid="waitlist-signup" style={{
            marginTop: 16, padding: 20,
            background: "var(--parchment-soft)",
            border: "1px solid var(--sand-line)",
        }}>
            {ok ? (
                <div data-testid="waitlist-success" style={{ fontFamily: "var(--font-serif)", color: "var(--cocoa)" }}>
                    <div style={{ fontStyle: "italic", fontSize: "1.2rem", marginBottom: 6 }}>
                        You&apos;re on the list.
                    </div>
                    <p style={{ margin: 0, opacity: 0.8, fontSize: 14 }}>
                        We&apos;ll email you the moment this piece returns to the Edit — one of one, first come first served.
                    </p>
                </div>
            ) : (
                <form onSubmit={submit}>
                    <div style={{
                        fontFamily: "var(--font-sans)", fontSize: 11, letterSpacing: "0.24em",
                        textTransform: "uppercase", color: "var(--cocoa)", marginBottom: 12,
                    }}>
                        {label}
                    </div>
                    <p style={{ margin: "0 0 12px", fontFamily: "var(--font-serif)", color: "var(--cocoa)", opacity: 0.8, fontSize: 14 }}>
                        Leave your email — we&apos;ll write to you the second this piece is available again.
                    </p>
                    {err && <div className="form-error" style={{ marginBottom: 12 }} data-testid="waitlist-error">{err}</div>}
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginBottom: 8 }}>
                        <input
                            className="input" type="text" placeholder="Your name (optional)"
                            value={name} onChange={(e) => setName(e.target.value)}
                            data-testid="waitlist-name"
                        />
                        <input
                            className="input" type="email" required placeholder="you@example.com"
                            value={email} onChange={(e) => setEmail(e.target.value)}
                            data-testid="waitlist-email"
                        />
                    </div>
                    <button className="btn" type="submit" disabled={saving} data-testid="waitlist-submit" style={{ width: "100%" }}>
                        {saving ? "Adding you…" : "Join the waitlist"}
                    </button>
                </form>
            )}
        </div>
    );
}
